import { isPublicDiagnosticSixTurnsEnabled } from '@/config/featureFlags';
import { isPrerendering } from '@/utils/prerender';

export type DiagnosticVariant = 'six_turn' | 'classic';

export const DIAGNOSTIC_VARIANT_KEY = 'swtpa.diagnosticVariant';

const isVariant = (v: string | null): v is DiagnosticVariant => v === 'six_turn' || v === 'classic';

/** The arm this browser already drew, or undefined. Never draws or stores one. */
export function storedDiagnosticVariant(): DiagnosticVariant | undefined {
  try {
    const stored = localStorage.getItem(DIAGNOSTIC_VARIANT_KEY);
    return isVariant(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Which diagnostic this visitor gets (#785). Flag off: classic for everyone.
 * Flag on: a sticky 50/50 draw; `?variant=six_turn|classic` forces and persists an arm for QA.
 * null while prerendering with the flag on: the static HTML must suit either arm.
 */
export function diagnosticVariant(): DiagnosticVariant | null {
  if (!isPublicDiagnosticSixTurnsEnabled()) return 'classic';
  if (isPrerendering()) return null;
  try {
    const forced = new URLSearchParams(window.location.search).get('variant');
    const stored = localStorage.getItem(DIAGNOSTIC_VARIANT_KEY);
    const variant: DiagnosticVariant = isVariant(forced)
      ? forced
      : isVariant(stored)
        ? stored
        : Math.random() < 0.5
          ? 'six_turn'
          : 'classic';
    localStorage.setItem(DIAGNOSTIC_VARIANT_KEY, variant);
    return variant;
  } catch {
    return 'six_turn';
  }
}
